import * as Types from '../Constants/AllConstants';

export const LoginReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.USER_LOGIN_REQUEST:
      return { loading: true };
    case Types.USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case Types.USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case Types.USER_LOGIN_RESET || Types.USER_LOGOUT:
      return {};
    default:
      return state;
  }
};


export const MyBusinessReducer = (
  state = { business: undefined, loading: false }, 
  action
) => {
  switch (action.type) {
    case Types.GET_MY_BUSINESS_REQUEST:
      return { ...state, loading: true, error: null };

    case Types.GET_MY_BUSINESS_SUCCESS:
      return { loading: false, business: action.payload ?? null, error: null };

    case Types.GET_MY_BUSINESS_FAIL:
      return { loading: false, business: null, error: action.payload };

    case Types.GET_MY_BUSINESS_RESET:
      return { business: undefined, loading: false, error: null };

    default:
      return state;
  }
};




export const UpdateProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PROFILE_UPDATE_REQUEST:
      return { loading: true };
    case Types.PROFILE_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case Types.PROFILE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PROFILE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const EnableOrDisableTwoFactorReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PROFILE_UPDATE_REQUEST:
      return { loading: true };
    case Types.PROFILE_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case Types.PROFILE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PROFILE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const ChangePasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PASSWORD_CHANGE_REQUEST:
      return { loading: true };
    case Types.PASSWORD_CHANGE_SUCCESS:
      return { loading: false, success: true };
    case Types.PASSWORD_CHANGE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PASSWORD_CHANGE_RESET:
      return {};
    default:
      return state;
  }
};

export const DeleteAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACCOUNT_DELETE_REQUEST:
      return { loading: true };
    case Types.ACCOUNT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.ACCOUNT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.ACCOUNT_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const GetAllUsersReducer = (
  state = { users: [], pages: 0, page: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case Types.USER_LIST_REQUEST:
      return { ...state, loading: true };

    case Types.USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
        totalElements: action.payload.totalElements,
        size: action.payload.size,
      };

    case Types.USER_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case Types.USER_GET_ALL_RESET:
      return { users: [], pages: 0, page: 0, loading: false, error: null };

    default:
      return state;
  }
};


// Reducer for viewing user details
export const ViewUserDetailsReducer = (state = { userDetails: {} }, action) => {
  switch (action.type) {
    case Types.USER_DETAILS_REQUEST:
      return { loading: true };
    case Types.USER_DETAILS_SUCCESS:
      return { loading: false, userDetails: action.payload };
    case Types.USER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};



// Reducer for viewing profile
export const ViewUserProfileReducer = (state = { profile: {}, viewOnly: false }, action) => {
  switch (action.type) {
    case Types.USER_PROFILE_REQUEST:
      return { ...state, loading: true };
    case Types.USER_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };
    case Types.USER_PROFILE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Types.SET_VIEW_ONLY:
      return { ...state, viewOnly: action.payload };
    default:
      return state;
  }
};



export const deleteAllUsersReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.USER_DELETE_ALL_REQUEST:
      return { loading: true };
    case Types.USER_DELETE_ALL_SUCCESS:
      return { loading: false, success: true };
    case Types.USER_DELETE_ALL_FAIL:
      return { loading: false, error: action.payload };
    case Types.USER_DELETE_ALL_RESET:
      return {};
    default:
      return state;
  }
};


export const CreateUserReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.USER_REGISTER_REQUEST:
      return { loading: true };
    case Types.USER_REGISTER_SUCCESS:
      return { loading: false,success: true, user: action.payload };
    case Types.USER_REGISTER_FAIL:
      return { loading: false,success: false, error: action.payload };
    case Types.USER_REGISTER_RESET:
      return {};
    default:
      return state;
  }
};


export const UpdateUserReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.USER_UPDATE_REQUEST:
      return { loading: true };
    case Types.USER_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case Types.USER_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.USER_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const ResetUserPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.RESET_USER_PASSWORD_REQUEST:
      return { loading: true };
    case Types.RESET_USER_PASSWORD_SUCCESS:
      return { loading: false, success: true };
    case Types.RESET_USER_PASSWORD_FAIL:
      return { loading: false, error: action.payload };
    case Types.RESET_USER_PASSWORD_RESET:
      return {};
    default:
      return state;
  }
};



export const GetAllRolesReducer = (state = { roles: [] }, action) => {
  switch (action.type) {
    case Types.ROLES_LIST_REQUEST:
      return { loading: true };
    case Types.ROLES_LIST_SUCCESS:
      return {
        loading: false,
        roles: action.payload,
      };
    case Types.ROLES_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.ROLES_LIST_RESET:
      return { roles: [] };
    default:
      return state;
  }
};


export const VerifyAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.VERIFY_ACCOUNT_REQUEST:
      return { loading: true };
    case Types.VERIFY_ACCOUNT_SUCCESS:
      return { loading: false, success: true };
    case Types.VERIFY_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    case Types.VERIFY_ACCOUNT_RESET:
      return {};
    default:
      return state;
  }
};


export const ResendVerificationReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.VERIFY_ACCOUNT_REQUEST:
      return { loading: true };
    case Types.VERIFY_ACCOUNT_SUCCESS:
      return { loading: false, success: true };
    case Types.VERIFY_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    case Types.VERIFY_ACCOUNT_RESET:
      return {};
    default:
      return state;
  }
};

export const twoFactorAuthReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TWO_FACTOR_AUTH_REQUEST:
      return { loading: true };
    case Types.TWO_FACTOR_AUTH_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload };
    case Types.TWO_FACTOR_AUTH_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const ChangeUserGroupReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CHANGE_USER_GROUP_REQUEST:
      return { loading: true };
    case Types.CHANGE_USER_GROUP_SUCCESS:
      return { loading: false, success: true, user: action.payload };
    case Types.CHANGE_USER_GROUP_FAIL:
      return { loading: false, error: action.payload };
    case Types.CHANGE_USER_GROUP_RESET:
      return {};
    default:
      return state;
  }
};

export const changeUserStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CHANGE_USER_STATUS_REQUEST:
      return { loading: true };
    case Types.CHANGE_USER_STATUS_SUCCESS:
      return { loading: false, success: true, user: action.payload };
    case Types.CHANGE_USER_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case Types.CHANGE_USER_STATUS_RESET:
      return {};
    default:
      return state;
  }
};
